<template>
  <div>
    <v-card tile flat v-if="FinancialAidApplication">
      <v-toolbar dense flat color="grey lighten-3">
        <v-app-bar-nav-icon @click="$router.go(-1)">
          <v-icon>mdi-chevron-left</v-icon>
        </v-app-bar-nav-icon>
        <v-toolbar-title class="text-capitalize">
          {{ FinancialAidApplication.fullName }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-row row wrap justify-space-between>
          <v-col shrink>
            <v-row>
              <v-col>
                <div class="text-capitalize">
                  <span class="font-weight-medium">Applicant Name: </span>
                  <span v-if="FinancialAidApplication.fullName">{{ FinancialAidApplication.fullName }}</span>
                  <span v-else>Not Set</span>
                </div>
                <div class="text-capitalize">
                  <span class="font-weight-medium">Phone Number: </span>
                  <span v-if="FinancialAidApplication.phoneNumber">{{ FinancialAidApplication.phoneNumber | USPhoneNumber }}</span>
                  <span v-else>Not Set</span>
                </div>
                <div>
                  <span class="font-weight-medium">Email: </span>
                  <span v-if="FinancialAidApplication.email">{{
                    FinancialAidApplication.email
                  }}</span>
                  <span v-else>Not Set</span>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-spacer></v-spacer>
          <v-col shrink>
            <div class="text-right">
              <div class="text-capitalize">
                <span class="font-weight-medium">Applicant Address: </span>
                <span v-if="FinancialAidApplication.address">{{ FinancialAidApplication.address }}</span>
                <span v-else>Not Set</span>
              </div>
              <div class="mt-1">
                <span class="font-weight-medium">Created At: </span>
                <span>{{ FinancialAidApplication.createdAt | moment("MM/DD/YYYY") }}</span>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-divider></v-divider>
    <v-container grid-list-lg fluid>
      <v-layout v-if="FinancialAidApplication">
        <v-flex>
          <v-card outlined>
            <v-toolbar dense flat color="grey lighten-3">
              <v-toolbar-title>Personal Details </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-row>
                <v-col>
                  <div class="text-decoration-underline">Marital Status</div>
                  <div class="text-capitalize font-weight-medium">{{ FinancialAidApplication.maritalStatus }}</div>
                </v-col>
                <v-col>
                  <div class="text-decoration-underline">Legal Status</div>
                  <div class="text-capitalize font-weight-medium">{{ FinancialAidApplication.legalStatus }}</div>
                </v-col>
                <v-col>
                  <div class="text-decoration-underline">Financial Aid</div>
                  <div class="text-capitalize font-weight-medium">{{ FinancialAidApplication.eligibleFor }}</div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-divider></v-divider>
    <v-container grid-list-lg fluid>
      <v-layout v-if="FinancialAidApplication">
        <v-flex>
          <v-card outlined>
            <v-toolbar dense flat color="grey lighten-3">
              <v-toolbar-title>Employment & Income Details </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-row>
                <v-col>
                  <div class="text-decoration-underline">Job Status</div>
                  <div class="text-capitalize font-weight-medium">{{ FinancialAidApplication.jobStatus }}</div>
                </v-col>
                <v-col>
                  <div class="text-decoration-underline">Monthly Salary</div>
                  <div class="text-capitalize font-weight-medium">{{ FinancialAidApplication.salary | currency }}</div>
                </v-col>
                <v-col>
                  <div class="text-decoration-underline">Other Income</div>
                  <div class="text-capitalize font-weight-medium">{{ FinancialAidApplication.otherIncome | currency }}</div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-divider></v-divider>
    <v-container grid-list-lg fluid>
      <v-layout v-if="FinancialAidApplication">
        <v-flex>
          <v-card outlined>
            <v-toolbar dense flat color="grey lighten-3">
              <v-toolbar-title>Add Comment & Update Status</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small :color="statusColor(FinancialAidApplication.status)" dark v-bind="attrs"
                    v-on="on">
                    {{ FinancialAidApplication.status }}
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item @click="FinancialAidApplication.status = status" v-for="(status, index) in statusItems"
                    :key="index">
                    <v-list-item-title>{{ status }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-toolbar>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-textarea
                    outlined
                    dense
                    hide-details
                    auto-grow
                    v-model="FinancialAidApplication.comment"
                    label="Comments"
                  ></v-textarea>
                </v-col>
                <v-col cols="4" sm="4">
                  <v-text-field outlined autofocus hide-details dense
                    v-model="amount" label="Amount"></v-text-field>
                </v-col>
                <v-col cols="4" sm="4">
                  <v-text-field outlined autofocus hide-details dense
                    v-model="FinancialAidApplication.investigatedBy" label="Investigated By"></v-text-field>
                </v-col>
                <v-col cols="4" sm="4">
                  <v-text-field outlined autofocus hide-details dense
                    v-model="FinancialAidApplication.approvedby" label="Approved By"></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" text @click="$router.go(-1)">Cancel</v-btn>
              <v-spacer> </v-spacer>
              <v-btn color="primary" dark @click="submit">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import applicationService from "../service.js";

export default {
  name: "edit-FinancialAidApplication",
  data() {
    return {
      loading: false,
      FinancialAidApplication: {
        fullName: null,
        phoneNumber: null,
        dob: null,
        email: null,
        address: null,
        legalStatus: null,
        maritalStatus: null,
        salary: null,
        otherIncome: null,
        jobStatus: null,
        eligibleFor: null,
      },
      amount: 0,
      statusItems: ['created', 'pending', 'approved', 'declined'],
    };
  },
  created() {
    this.loadData()
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
  },
  methods: {
    statusColor(status) {
      let color = 'green'
      switch (status) {
        case 'pending':
          color = '#1976D2'
          break;
        case 'declined':
          color = 'red'
          break;
        case 'created':
          color = '#AED581'
          break;
        case 'approved':
          color = '#00BFA5'
          break;
        default:
          color = 'green'
      }

      return color
    },
    onFilePicked(e) {
      const { files } = e.target;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf('.') <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', () => {
          this.FinancialAidApplication.license = fr.result;
        });
      } else {
        this.imageName = '';
        this.FinancialAidApplication.image = '';
        this.FinancialAidApplication.license = '';
      }
    },
    pickFile() {
      this.$refs.image.click();
    },
    loadData(){
      const { id } = this.$route.params;
      return applicationService.getById(id).then((response) => {
        console.log("Loading data response ", response)
        this.FinancialAidApplication = response.data;
        if(this.FinancialAidApplication.metadata){
          this.amount = this.FinancialAidApplication.metadata.amount
        }
        return response;
      }).catch((error) => {
        console.log("error", error);
      });
    },
    submit() {
      this.loading = true;
      if(!this.FinancialAidApplication.metadata){
        this.FinancialAidApplication.metadata = {
          amount: this.amount
        }
      } else {
        this.FinancialAidApplication.metadata.amount = this.amount
      }
      return applicationService
        .update(this.FinancialAidApplication.id, this.FinancialAidApplication)
        .then((result) => {
          if (result.status) {
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "success",
                title: "FinancialAidApplication is updated",
              });
            this.loading = false;
            this.loadData();
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: err.data.message,
            });
        });
    },
  },
};
</script>